import React, {useContext, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {mapDateFormat} from 'src/utils/mapDateFormat';

import {FormattedDate} from '@pb/kit-component-formatters';
import {LocaleContext} from '@pb/kit-context-locale';


import {
    userSearchResultAuditDataSelector,
    userSearchResultAuditResultSelector,
} from '../../slices/user-search-result-audit.slice';

type Props = {
    userId: number,
};

export const LastModifiedDateCell = ({userId}: Props) => {
    const {isLoading, loadingError} = useSelector(userSearchResultAuditDataSelector);
    const result = useSelector(userSearchResultAuditResultSelector);
    const {locale} = useContext(LocaleContext);

    const lastModifiedDate = useMemo(
        () => result?.data[userId]?.lastUpdated.eventTime,
        [result, userId],
    );

    if (isLoading || loadingError || !lastModifiedDate) {
        return null;
    }

    return (
        <span>{FormattedDate.format({
            value: lastModifiedDate,
            format: mapDateFormat(locale.dateFormat, 'NUMERIC'),
        })}
        </span>
    );
};
